import { useMemo } from 'react';
import { TextAnimatedContainer, TextAnimatedSpan } from '../animation/TextAnimations.styles';
import { jsx as _jsx } from "react/jsx-runtime";
const TextAnimations = ({
  text
}) => {
  const getKey = (index, item) => index + item + Math.random();
  const getSpan = () => /*#__PURE__*/_jsx(TextAnimatedSpan, {
    id: 'animatedSpan',
    steps: text.length,
    children: text
  }, getKey(1, text));
  const AnimatedTextCached = useMemo(getSpan, [text]);
  return /*#__PURE__*/_jsx(TextAnimatedContainer, {
    children: AnimatedTextCached
  });
};
export default TextAnimations;